import { render, staticRenderFns } from "./BottomCompany.vue?vue&type=template&id=05810d05&scoped=true&"
import script from "./BottomCompany.vue?vue&type=script&lang=js&"
export * from "./BottomCompany.vue?vue&type=script&lang=js&"
import style0 from "./BottomCompany.vue?vue&type=style&index=0&id=05810d05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05810d05",
  null
  
)

export default component.exports